import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupTradeEditRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/trades/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/group/Trades/GroupTradeEditPage/GroupTradeEditPage').then((d) => d.Route)
);
